// extracted by mini-css-extract-plugin
export default {"PasswordReset":"styles_PasswordReset__yhJOH","LoginButton":"styles_LoginButton__76ipS"};